import { apiClient } from '@/lib/api-client'

export interface PromptEntry {
  id: 'extract_terms' | 'detect_metadata' | 'gloss' | 'judge'
  prompt: string
  /** Settings that travel with the prompt: thresholds, limits, input shape. */
  params: Record<string, string | number>
}

/** Every system prompt in use, in pipeline order. Read-only; they live in code. */
export async function getPrompts(): Promise<{ model: string; prompts: PromptEntry[] }> {
  const { data } = await apiClient.get<{ model: string; prompts: PromptEntry[] }>('/prompts')
  return { model: data.model ?? '', prompts: data.prompts ?? [] }
}
